import calculateBootResult from 'owa-shared-start/lib/calculateBootResult';
import createBootError from 'owa-shared-start/lib/createBootError';
import sleep from 'owa-sleep';
import { appendMiscData } from 'owa-shared-start/lib/miscData';
import { createBootReliabilityAriaEvent } from 'owa-shared-start/lib/createBootReliabilityAriaEvent';
import { createStatusErrorMessage } from 'owa-shared-start/lib/createStatusErrorMessage';
import { getApp, scrubForPii } from 'owa-config';
import { getRetryStrategyFromError } from './getRetryStrategyFromError';
import { getServerErrorDiagnostics } from 'owa-shared-start/lib/getServerErrorDiagnostics';
import { lazyPostSignal } from 'mini-start-analytics';
import { unblockLazyLoadCallbacks } from 'owa-bundling-light';
import type RetryStrategy from 'owa-shared-start/lib/interfaces/RetryStrategy';
import type ErrorDiagnostics from 'owa-shared-start/lib/interfaces/ErrorDiagnostics';
import type { BootResult } from 'owa-shared-start-types';

export async function onBeforeRetry(endpoint: string, response: Response) {
    // unblock lazy load callbacks to enable lazy boot-failure logging
    unblockLazyLoadCallbacks();

    const error = createBootError(
        createStatusErrorMessage(response),
        'StartupData',
        scrubForPii(response.url)
    );
    const errorDiagnostics = getServerErrorDiagnostics(error);
    const retryStrategy: RetryStrategy | null = getRetryStrategyFromError(
        calculateBootResult(error, errorDiagnostics),
        errorDiagnostics.esrc
    );
    if (retryStrategy) {
        await logRetry('serverRetry', error, errorDiagnostics);
        if (retryStrategy.waitFor) {
            // timeout the waitFor by 10 seconds and ignore errors
            await Promise.race([sleep(10000), retryStrategy.waitFor.catch(() => {})]);
        }
        return {
            endpoint: `${endpoint}?bO=1&app=${getApp()}`,
            delay: retryStrategy.timeout,
        };
    }
    return undefined;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export function logRetry(eventName: BootResult, error: any, errorDiagnostics?: ErrorDiagnostics) {
    appendMiscData('StartupDidRetry', 't');
    return lazyPostSignal.importAndExecute(
        createBootReliabilityAriaEvent(
            eventName,
            errorDiagnostics || getServerErrorDiagnostics(error),
            undefined,
            error
        )
    );
}
